import { array, bool, string } from 'prop-types'
import { Component } from 'react'
import { kuiperClassNames, ListManager } from '@opallabs/kuiper'
import { getNestedProperty } from '@opallabs/lambda'
import PhaseContainer from '../PhaseContainer'

import './styles.scss'

const noop = () => {}

export default class CompletedPhases extends Component {
  static propTypes = {
    allPhasesComplete: bool,
    finalApprovalReached: bool.isRequired,
    phases: array.isRequired,
    workflowLocation: string,
  }

  constructor(props) {
    super(props)

    const onlyOneCompletePhase =
      getNestedProperty(props, 'phases', 'length') <= 1
    const expanded = onlyOneCompletePhase || props.allPhasesComplete
    this.state = { expanded }
  }

  onTrucatedListClick = () => {
    this.setState({ expanded: true })
  }

  renderTruncatedList() {
    const { finalApprovalReached, phases } = this.props
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    return (
      <div
        className={kuiperClassNames(
          'phase',
          'complete',
          'truncatedCompletedPhases',
          {
            finalApproval: finalApprovalReached,
          }
        )}
        onClick={this.onTrucatedListClick}
      >
        <span>{`${phases.length} Completed Phases`}</span>
        {finalApprovalReached && <span>Approved</span>}
      </div>
    )
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  }

  renderDetailedList() {
    return (
      <ListManager
        animate={true}
        animationName={null}
        createItem={noop}
        createPhaseItem={noop}
        itemRenderer={PhaseContainer}
        items={this.props.phases}
        onChangeDate={noop}
        onChangeName={noop}
        onChangePhaseOptions={noop}
        onDestroyPhaseItem={noop}
        onItemMoved={noop}
        onRetractApprovals={noop}
        onSendForApproval={noop}
        removeItem={noop}
        updateItem={noop}
        updatePhaseItem={noop}
        workflowLocation={this.props.workflowLocation}
      />
    )
  }

  render() {
    return this.state.expanded
      ? this.renderDetailedList()
      : this.renderTruncatedList()
  }
}
